<div class="pagination-container">
  <button
    (click)="goToPage(currentPage - 1)"
    [disabled]="currentPage === 1"
    class="pagination-button-previous"
  >
    {{ "pagination.prev" | translate }}
  </button>

  <span class="pagination-page-info">
    {{ "pagination.page" | translate }}
  </span>

  <input
    (input)="onInputPageChange($any($event.target).value)"
    [max]="totalPages"
    [value]="inputPage"
    class="pagination-input"
    min="1"
    type="number"
  />

  <span class="pagination-page-info">
    {{ "pagination.of" | translate }} {{ totalPages }}
  </span>

  <button
    (click)="goToPage(currentPage + 1)"
    [disabled]="currentPage === totalPages"
    class="pagination-button-next"
  >
    {{ "pagination.next" | translate }}
  </button>

  <select
    #pageSize
    (change)="onPageSizeChange(pageSize.value)"
    [value]="pageSize"
    class="pagination-select"
  >
    @for (size of pageSizeOptions; track $index) {
      <option [value]="size">
        {{ size }} {{ "pagination.perPage" | translate }}
      </option>
    }
  </select>
</div>
